import React, { FC, useState } from 'react';
import { useGetProgramMasterData } from 'src/api/mutations/useGetProgramMasterData';
import './IncreaseStrengthSteps.scss'; // Reusing the same SCSS for consistency
import { ReactComponent as General_staminaIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/general_stamina.svg';
import { ReactComponent as CardiovascularIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/cardiovascular.svg';
import { ReactComponent as Sport_specificIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/sport_specific.svg';
import { ReactComponent as MuscularIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/muscular.svg';
import { ReactComponent as RunningIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/running.svg';
import { ReactComponent as CyclingIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/cycling.svg';

interface EnduranceStep1Props {
  value?: string;
  onNext?: (value: string) => void;
}

const iconMap: Record<string, React.ReactNode> = {
  cardiovascular: <CardiovascularIcon />,
  muscular: <MuscularIcon />,
  running: <RunningIcon />,
  cycling: <CyclingIcon />,
  sport_specific: <Sport_specificIcon />,
  general_stamina: <General_staminaIcon />,
};

// What type of endurance should this program improve?
export const EnduranceStep1: FC<EnduranceStep1Props> = ({ value, onNext }) => {
  const [selectedType, setSelectedType] = useState<string>(value || '');
  const { data: programMasterData, isLoading, isError } = useGetProgramMasterData();

  const groupData = programMasterData?.trainingGoalDetails?.groups?.find(
    (g: any) => g.goalId === 'endurance',
  );

  const types = groupData?.options
    ? [...groupData.options].sort((a: any, b: any) => a.order - b.order)
    : [];

  if (isLoading) {
    return <div className="increase-strength-step">{'Loading options...'}</div>;
  }

  if (isError || !groupData) {
    return <div className="increase-strength-step">{'Error loading options.'}</div>;
  }

  return (
    <div className="increase-strength-step">
      <h2 className="step-title">{groupData?.title}</h2>

      <div className="goal-buttons">
        {types.map((type: any) => (
          <button
            key={type.id}
            className={`goal-btn ${selectedType === type.slug ? 'selected' : ''}`}
            onClick={() => {
              setSelectedType(type.slug);
              if (onNext) onNext(type.slug);
            }}
          >
            <div className="goal-icon">{iconMap[type.id]}</div>
            <span className="goal-label">{type.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
